/* eslint-disable no-restricted-imports */
import { useESpotDataFromName } from '@/data/Content/_ESpotDataFromName';
import { ID } from '@/data/types/Basic';
import { ProcessedContent } from '@/data/types/Marketing';
import { dataMapContent } from '@/data/utils/dataMapContent';
import { useMemo } from 'react';

const EMAIL_RECOMMENDED_COUPON_POPUP_TAG = 'dp-email-campaign-coupon-popup';

export interface EmailRecommendedCouponPopupContentProps {
	couponCode: string;
	couponLabel: string;
	couponExpiry: string;
}

const getTagAttribute = (tag: string, attribute: string) => {
	const match = tag.match(new RegExp(`${attribute}="([^"]*)"`));

	return match?.at(1);
};

export const getEmailRecommendedCouponPopupPropsFromContent = (
	content?: ProcessedContent[]
): EmailRecommendedCouponPopupContentProps | undefined => {
	const text = content?.find(({ text }) =>
		text?.includes(`<${EMAIL_RECOMMENDED_COUPON_POPUP_TAG}`)
	)?.text;
	const tag = text?.match(new RegExp(`<${EMAIL_RECOMMENDED_COUPON_POPUP_TAG}[^>]*>`))?.at(0);

	if (!tag) {
		return undefined;
	}

	const couponCode = getTagAttribute(tag, 'couponcode');
	const couponLabel = getTagAttribute(tag, 'couponlabel');
	const couponExpiry = getTagAttribute(tag, 'couponexpiry');

	if (!couponCode || !couponLabel || !couponExpiry) {
		return undefined;
	}

	return { couponCode, couponLabel, couponExpiry };
};

export const useEmailRecommendedCouponPopupRecommendation = (emsName?: ID) => {
	const { data, loading, error } = useESpotDataFromName(emsName);

	const content = useMemo(
		() => getEmailRecommendedCouponPopupPropsFromContent(dataMapContent(data)),
		[data]
	);

	return { content, loading, error };
};
